import * as React from 'react';
import { getCurrencyFormat } from '../../helpers/currency-format';

interface IPackagesProgressHeaderProps {
    packageTotalCount: number;
    currentItemIndex: number;
    packageProgressMessage: string;
    venueName: string;
    showPackageProgressBar: boolean;
    showComponent: boolean;
    seatQuantityText: string;
    packagePriceText: string;
    flexInstructions: string;
    currencyFormat: string;
    packageTotalPrice: number;
    selectedQuantity: number;
}

class PackagesProgressHeader extends React.PureComponent<IPackagesProgressHeaderProps, any>{
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.showComponent)
            return null;

        var progressBar = [];

        for (var i = 1; i <= this.props.packageTotalCount; i++) {
            var className = "packages-progress-unreserved";
            if (i < this.props.currentItemIndex) {
                className = "packages-progress-reserved";
            }
            else if (i == this.props.currentItemIndex) {
                className = "packages-progress-active";
            }

            const classes = `${className} packages-progress-item`;

            progressBar.push(<span key={i} className={classes}>{i}</span>)
        }

        return (
            <section className="filters-section packages-progress-section">
                <div className="packages-progress-section-inner">
                    <div>
                        <div className="packages-progress-section-heading">
                            <p className="caption-paragraph"><strong>{this.props.packageProgressMessage}</strong></p>
                            <p className="caption-paragraph"><strong>{this.props.venueName}</strong></p>
                        </div>
                        {
                            this.props.showPackageProgressBar ?
                                <div className="packages-progress-container">{progressBar}</div>
                                : null
                        }

                        <p className="packages-progress-instructions">{this.props.flexInstructions}</p>
                    </div>

                </div>
                <div className="packages-progress-total-container">
                    <div className="packages-progress-section-inner">
                        <p className="caption-paragraph">{this.props.seatQuantityText} {this.props.selectedQuantity.toString()}</p>
                        <p className="caption-paragraph">{this.props.packagePriceText} {getCurrencyFormat(this.props.currencyFormat, this.props.packageTotalPrice)}</p>
                    </div>
                </div>
            </section>
        );
    }
}

export default PackagesProgressHeader;